import { F, L } from "../styles/theme.js";

export function CreatePersonaStep2({ kbDrafts, busy, saveErr, onUpdate, onToggle, onRemove, onSave }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ padding: "12px 14px", background: "#0d1724", border: "1px solid #1e2d45", borderRadius: 10, fontSize: 12, color: "#64748b", lineHeight: 1.6 }}>
        ℹ️ These entries <strong style={{ color: "#94a3b8" }}>train the AI clone's knowledge base</strong>. Uncheck or remove entries you don't want. You can edit topics, content, and source URLs before saving.
      </div>

      {kbDrafts.map((entry, idx) => (
        <div key={entry.id}
          style={{
            background: entry.checked ? "#0d1724" : "#090e1a",
            border: `1px solid ${entry.checked ? "#1e3a5f" : "#1e2d45"}`,
            borderRadius: 12, padding: 14, opacity: entry.checked ? 1 : 0.5, transition: "all .2s",
          }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: entry.checked ? 12 : 0 }}>
            <input type="checkbox" checked={entry.checked} onChange={() => onToggle(entry.id)}
              style={{ width: 16, height: 16, cursor: "pointer", accentColor: "#3b82f6", flexShrink: 0 }} />
            <span style={{ fontSize: 12, fontWeight: 700, color: "#94a3b8", flex: 1 }}>Entry {idx + 1}</span>
            <button onClick={() => onRemove(entry.id)}
              style={{ background: "none", border: "none", color: "#475569", cursor: "pointer", fontSize: 16, padding: "0 4px", lineHeight: 1 }}
              title="Remove entry">✕</button>
          </div>

          {entry.checked && (
            <div style={{ display: "flex", flexDirection: "column", gap: 9 }}>
              <div>
                <label style={{ ...L, marginBottom: 4 }}>Topic</label>
                <input style={F} value={entry.topic} onChange={e => onUpdate(entry.id, "topic", e.target.value)} />
              </div>
              <div>
                <label style={{ ...L, marginBottom: 4 }}>Content</label>
                <textarea style={{ ...F, minHeight: 72, resize: "vertical", lineHeight: 1.6 }}
                  value={entry.content} onChange={e => onUpdate(entry.id, "content", e.target.value)} />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 9 }}>
                <div>
                  <label style={{ ...L, marginBottom: 4 }}>Source Title</label>
                  <input style={F} placeholder="e.g. Official Campaign Site"
                    value={entry.source_title} onChange={e => onUpdate(entry.id, "source_title", e.target.value)} />
                </div>
                <div>
                  <label style={{ ...L, marginBottom: 4 }}>Source URL</label>
                  <input style={F} placeholder="https://…"
                    value={entry.source_url} onChange={e => onUpdate(entry.id, "source_url", e.target.value)} />
                </div>
              </div>
            </div>
          )}
        </div>
      ))}

      <div style={{ display: "flex", gap: 9, padding: "8px 10px", background: "#090e1a", borderRadius: 8, fontSize: 11, color: "#475569" }}>
        ✅ {kbDrafts.filter(e => e.checked).length} of {kbDrafts.length} entries selected
      </div>

      {saveErr && (
        <div style={{ padding: "10px 13px", background: "#ef444414", border: "1px solid #ef444430", borderRadius: 9, fontSize: 12, color: "#ef4444" }}>
          ⚠ {saveErr}
        </div>
      )}

      <button onClick={() => onSave(kbDrafts.filter(e => e.checked))} disabled={busy}
        style={{ padding: "14px",
          background: busy ? "#1e2d45" : "linear-gradient(135deg,#2563eb,#1d4ed8)",
          color: busy ? "#475569" : "#fff",
          border: "none", borderRadius: 11, fontSize: 14, fontWeight: 700,
          cursor: busy ? "not-allowed" : "pointer", fontFamily: "inherit" }}>
        ✦ Confirm & Save Clone
      </button>
    </div>
  );
}
